import React, { Component } from 'react';
import { Editors } from 'react-data-grid-addons';

const { DropDownEditor } = Editors;

export function ConseilorEditor(conseilors) {
  let conseilorList =
    conseilors == null
      ? []
      : conseilors.map((d) => {
          return {
            id: d.shortname + ' - ' + d.name,
            value: d.name + '|' + d.type,
            title: d.shortname + ' - ' + d.name,
            text: d.shortname + ' - ' + d.name,
          };
        });
  return <DropDownEditor options={conseilorList} />;
}

export function LoyaltyConquestEditor() {
  const loyaltyConquestTypes = [
    { id: 'NULL', value: null, title: ' ', text: ' ' },
    { id: 'Fidé', value: 'Fidé', title: 'Fidé', text: 'Fidé' },
    { id: 'Conquête', value: 'Conquête', title: 'Conquête', text: 'Conquête' },
  ];

  return <DropDownEditor options={loyaltyConquestTypes} />;
}

export function ModelEditor(models) {
  let modelList =
    models == null
      ? []
      : models.map((m) => {
          return { id: m.model, value: m.model, title: m.model, text: m.model };
        });
  return <DropDownEditor options={modelList} />;
}

export function ShortnameEditor(dealerships) {
  let dealershipList =
    dealerships == null
      ? []
      : dealerships.map((d) => {
          return { id: d.name, value: d.name, title: d.name, text: d.name };
        });
  return <DropDownEditor options={dealershipList} />;
}

export function TypeEditor() {
  const types = [
    { id: 'NULL', value: null, title: ' ', text: ' ' },
    { id: 'VPP', value: 'VPP', title: 'VPP', text: 'VPP' },
    { id: 'VD', value: 'VD', title: 'VD', text: 'VD' },
    { id: 'SO', value: 'SO', title: 'SO', text: 'SO' },
  ];

  return <DropDownEditor options={types} />;
}



// WEBPACK FOOTER //
// ./src/Components/DataGrid/Editors.js